var exports = {
  "u": "x805b157e--ad2cb7--tip",
  "r": "x805b157e--ad2cb7--disabled",
};

module.exports = exports;
